import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLoginComponent} from './pages/app.login.component';
import { LoanApplicationComponent } from './loan-application/loan-application.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { RunMyNumbersComponent } from './run-my-numbers/run-my-numbers.component';
import { AuthGuard } from './utilities/auth.guard';
import { LoanApplicationReadOnlyComponent } from './admin/loan-application-read-only/loan-application-read-only.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
            path: '', component: LoanApplicationComponent},
            {path: 'dashboard', component: AppMainComponent,
                children: [
                    {path: '', component: DashboardComponent, canActivate: [AuthGuard]},
                    {path: 'application', component: LoanApplicationReadOnlyComponent, canActivate: [AuthGuard]},
                ]
            },
            {path: 'quote', component: RunMyNumbersComponent},
            {path: 'error', component: AppErrorComponent},
            {path: 'access', component: AppAccessdeniedComponent},
            {path: 'notfound', component: AppNotfoundComponent},
            {path: 'login', component: AppLoginComponent},
            {path: '**', redirectTo: '/notfound'},
        ], {scrollPositionRestoration: 'enabled'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
